export default __webpack_public_path__ + "static/media/add-plus-circle.c080722e.svg";